import React, { useState } from 'react';
import Logo from '../../_assets/images/logo@2x.png';
import status from 'http-status';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userService } from '../../_services/user.service'
import { alertActions } from '../../_actions/alert.actions'

function ForgotPassword({ dispatch, alert }) {
  const [request, setRequest] = useState(false);
  const [practiceId, setPracticeId] = useState('');
  const [username, setUsername] = useState('');

  return <div className="row h-100">
    <div className="col-lg-10 offset-lg-1 my-auto">
      <div className="card axs-shadow container">
        <div className="row">
          <div className="col-lg-4 d-flex" style={{ backgroundColor: '#1AB2E9' }}>
            <img src={Logo} alt="AxS Logo" className="m-auto" />
          </div>
          <div className="col-lg-8">
            <div className='p-4'>
              <h3 className="mt-3 text-center">Forgot Password</h3>
              <p className="text-center lead">Let's try to find your account.</p>

              <form >
                {alert.message &&
                  <div className={`alert my-4 ${alert.type}`}>{alert.message}</div>
                }

                <div className="form-group">
                  <label htmlFor="practiceId">Practice ID</label>
                  <input value={practiceId} onChange={e => setPracticeId(e.target.value)} type="text" className="form-control" name="practiceId" />
                </div>

                <div className="form-group">
                  <label htmlFor="username">Username</label>
                  <input value={username} onChange={e => setUsername(e.target.value)} type="text" className="form-control" name="username" />
                </div>

                <div className="form-group">
                  <button onClick={() => {
                    setRequest(true);

                    userService.forgotPassword(practiceId, username)
                      .then(() => {
                        setRequest(false);
                        setPracticeId('');
                        setUsername('');

                        dispatch(alertActions.success('A reset password email has been sent!'))
                      })
                      .catch((error) => {
                        setRequest(false);

                        if (error.response && error.response.status === status.UNPROCESSABLE_ENTITY) {
                          dispatch(alertActions.error('Provider ID and Username is required.'));
                        } else if (error.response && error.response.status === status.NOT_FOUND) {
                          dispatch(alertActions.error(error.response.data.message));
                        } else {
                          dispatch(alertActions.error('Could not reset your password at this time. Please try again.'))
                        }
                      });
                  }}
                    disabled={request || username === '' || practiceId === ''}
                    type="button"
                    className="btn btn-primary btn-block mt-5">{request ? 'Forgot Password...' : 'Forgot Password'}</button>
                </div>

                <Link to="/login" className="btn btn-link btn-block text-center">Login</Link>
              </form>
            </div>

          </div>
        </div>
      </div>
      <div className="text-center mt-4">
        <small>v{process.env.REACT_APP_API_VERSION} (Build {process.env.REACT_APP_BUILD})</small>
      </div>
    </div>
  </div>
}

const mapStateToProps = state => {
  return {
    alert: state.alert
  };
}

export default connect(mapStateToProps)(ForgotPassword);